import PropTypes from 'prop-types';
import { labelValuePairProp, textProp } from '../../../tools/customProps';
import { shippingAddress } from '../props';

export const stepTwoProps = PropTypes.shape({
  title: labelValuePairProp,
  returnAvoidCancellation: textProp,
  carrierLocator: textProp,
  returnByDate: textProp,
  rmaNumber: labelValuePairProp,
  searchQRCodeLocations: textProp,
  nextStepsQRCodeProvided: textProp,
  eligibleDropOffLocations: labelValuePairProp,
  qrCodePurolatorServiceDetails: textProp,
  dhlReturnNote: textProp,
  dhlReturnNumber: textProp,
  returnMethodCustomerShippingShipTo: textProp,
  returnAddress: textProp,
  returnLabelGenerated: textProp,
  returnLabelWaiting: textProp,
  returnLabelProvided: textProp,
});

export const stepFourProps = PropTypes.shape({
  title: labelValuePairProp,
  exchangeShipToLocationTitle: textProp,
  exchangeShippingLocation: PropTypes.shape(shippingAddress),
  exchangeStandardShipping: textProp,
  exchangesStandardShippingTimeFrame: textProp,
});

export const nextStepsProps = {
  nextSteps: PropTypes.shape({
    title: textProp,
    stepOne: labelValuePairProp,
    stepTwo: stepTwoProps,
    stepThree: labelValuePairProp,
    stepFour: stepFourProps,
  }),
};

export const stepTitleProps = {
  stepNumber: PropTypes.string,
  title: labelValuePairProp,
};
